import script from "./RouteSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteSingle.vue?vue&type=script&setup=true&lang=js"

import "./RouteSingle.vue?vue&type=style&index=0&id=2ebf083f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ebf083f"]])

export default __exports__